import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import { getColor } from 'common/constants/_colors';

export const StyledProviderName = styled(Flex)`
  color: ${({ isSelected }) => getColor(isSelected ? 'shark' : 'shuttleGray')};
`;

export const StyledSectionWrapper = styled(Flex)`
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
`;

export const StyledButtonWrapper = styled(Flex)`
  flex-direction: column;
  width: 12rem;
  height: 100%;
  font-weight: 700;
`;
export const StyledWrapper = styled(Flex)`
  box-shadow: 4px 0 10px 0 rgba(0, 0, 0, 0.05);
  background-color: white;
  padding: 4rem;
`;
